"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var app_1 = __importDefault(require("firebase/app"));

var firebase_1 = require("../../configs/firebase");

function fetch(_x) {
  return _fetch.apply(this, arguments);
}

function _fetch() {
  _fetch = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_ref) {
    var after, group_id, snapshots, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            after = _ref.after, group_id = _ref.group_id;
            _context.next = 3;
            return app_1.default.firestore().collection(firebase_1.CN_DELETED_ITEMS).where('group_id', '==', group_id).orderBy('create_at', 'asc').startAfter(after).get();

          case 3:
            snapshots = _context.sent;

            if (!(snapshots.size === 0)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", []);

          case 6:
            result = [];
            snapshots.forEach(function (docSnapshot) {
              result.push(docSnapshot.data());
            });
            return _context.abrupt("return", result);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetch.apply(this, arguments);
}

exports.fetch = fetch;

function getItemIdsAfter(_x2) {
  return _getItemIdsAfter.apply(this, arguments);
}

function _getItemIdsAfter() {
  _getItemIdsAfter = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(opts) {
    var docs;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetch(opts);

          case 2:
            docs = _context2.sent;
            return _context2.abrupt("return", docs.map(function (doc) {
              return doc.item_id;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getItemIdsAfter.apply(this, arguments);
}

exports.getItemIdsAfter = getItemIdsAfter;